import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDU4iDVm_xmXo6jmJBbgzqgcNMAsh_JHCs",
  authDomain: "rosterable-302b0.firebaseapp.com",
  projectId: "rosterable-302b0",
  storageBucket: "rosterable-302b0.firebasestorage.app",
  messagingSenderId: "155430236549",
  appId: "1:155430236549:web:5a8bbdbf6ef617d39154ec",
  measurementId: "G-XMLVV0E4DF"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

// Callable Cloud Functions. The Pick Up functions set no region (only maxInstances via
// setGlobalOptions), so they deploy to the default us-central1 — which is exactly what
// getFunctions(app) targets by default, so no region argument is needed. httpsCallable
// attaches the signed-in user's ID token automatically. (Unlike iOS, the web JS SDK has
// no Release-build callable bug, so we call these directly — no CloudFunctionCaller.)
export const functions = getFunctions(app);

// Google Analytics — this is what feeds DAU for the web client. The iOS app
// reports DAU automatically through its SDK; on the web we have to initialize
// Analytics ourselves, which is why web DAU wasn't showing up. isSupported()
// guards environments where Analytics can't run so it never throws; once
// initialized it auto-collects page_view and session events that drive DAU.
export let analytics = null;
isSupported()
  .then((supported) => {
    if (supported) analytics = getAnalytics(app);
  })
  .catch(() => { /* Analytics unavailable in this environment — safe to ignore */ });
